//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/PlotColorsWidthsBuilder.js";
import "../no/PlotSourceBuilder.js";
import "../no/PlotColorsWidthsBuilder.js";
import "../no/PlotSourceBuilder.js";
let d=[[[0,"BannerMessage",1,0],[0,"CharacterSize",1,0],[0,"ClsfData",1,0],[1,"ColorsWidthsBuilder",0,"PlotColorsWidthsBuilder",0],[0,"Copies",1,0],[0,"CustomSymbolsInForeground",1,0],[0,"DisplayBanner",1,0],[0,"ImageResolution",1,0],[0,"JobName",1,0],[0,"Justification",1,0],[0,"PlotType",1,0],[0,"PlotterText",1,0],[0,"PrinterGroupText",1,0],[0,"ProfileText",1,0],[0,"RasterImages",1,0],[0,"Rotation",1,0],[0,"ShadedGeometry",1,0],[1,"SourceBuilder",0,"PlotSourceBuilder",0],[0,"Tolerance",1,0],[0,"Units",1,0],[0,"XDisplay",1,0],[0,"XOffset",1,0],[0,"YDisplay",1,0],[0,"YOffset",1,0]],[[[],"AddToPlotLayout",{},0,0],[[],"ClearPlotLayout",{},0,0],[[],"SaveCgm",{},0,0],[[],"AdvancedPlot",{},0,0],[["nFilenames"],"GetFilenames",{R_:{filenames:""}},0,0],[["filenames"],"SetFilenames",{},1,0],[["nFilenames"],"GetGraphicFilenames",{R_:{filenames:""}},0,0],[["filenames"],"SetGraphicFilenames",{},1,0]],[]];
SPLM.PlotBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PlotBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PlotBuilder.PlotTypes = Object.freeze({
    "Standard" : "Standard", "UsingLayout" : "UsingLayout"});

SPLM.PlotBuilder.UnitsOption = Object.freeze({
    "Metric" : "Metric", "English" : "English"});

SPLM.PlotBuilder.XdisplayOption = Object.freeze({
    "Left" : "Left", "Center" : "Center", "Right" : "Right"});

SPLM.PlotBuilder.YdisplayOption = Object.freeze({
    "Bottom" : "Bottom", "Center" : "Center", "Top" : "Top"});

SPLM.PlotBuilder.RotationOption = Object.freeze({
    "Degree0" : "Degree0", "Degree90" : "Degree90", "Degree180" : "Degree180", "Degree270" : "Degree270"});

SPLM.PlotBuilder.JustificationOption = Object.freeze({
    "Left" : "Left", "Center" : "Center", "Right" : "Right"});

SPLM.PlotBuilder.ImageResolutionOption = Object.freeze({
    "Draft" : "Draft", "Low" : "Low", "Medium" : "Medium", "High" : "High"});

export default SPLM;